<div class="blank_receipt-page">
  <div class="order-page-title" id="top">
    <div class="blank_receipt-page-title">
      <eps-button class="edit-button" (buttonClick)="backClicked()" label="SHARED.BUTTONS.BACK"></eps-button>
      <span class="title" [innerHTML]="'STOCK_COUNT.CREATE.TITLE' | translate"></span>
    </div>
    <div>
      <div *ngIf="!stockCountOrders && !materials" class="blank_receipt-page-search">
        <!-- step 1: select a ship to -->
       <stock-count-create-location [isSaving]="isSaving" [shipTos]="shipTos" (selectedShipTo)="selectedShipToUpdated($event)"></stock-count-create-location>
      </div>
      <div *ngIf="stockCountOrders && !materials" class="blank_receipt-page-search">
        <!-- step 2: select order(s) -->
        <stock-count-list-orders [orders]="stockCountOrders" [definitions]="definitions" [shipTos]="fullShipTos" (goToCounts)="goToCounts($event)"> </stock-count-list-orders>
      </div>
      <div *ngIf="materials" class="blank_receipt-page-search">
        <!-- step 3: enter counts -->
        <stock-count-material-list class="blank_receipt-page-search" [materials]="materials" [definitions]="definitions" (getCreateStockCount)="createStockCount($event)">
        </stock-count-material-list>
      </div>
    </div>
  </div>
</div>
